import { object, string, boolean } from 'yup'
import {
  commonFormInitialValues,
  commonFormValidationSchema,
  CommonFormValues
} from '@/utils/functions/form'

type FormValues = {
  designation: string
  contact_consent: boolean
  terms_conditions: boolean
}

export type ResourceFormValues = CommonFormValues & FormValues

export interface ResourceFormValuesAPI extends ResourceFormValues {
  url: string
}

export const initialFormValues = {
  ...commonFormInitialValues,
  designation: '',
  contact_consent: false,
  terms_conditions: false
}

export const ResourceFormValidationSchema = commonFormValidationSchema.concat(
  object().shape({
    designation: string().required('Please enter your designation'),
    contact_consent: boolean(),
    terms_conditions: boolean().required(
      'Please accept the terms and conditions'
    )
  })
)
